import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './component/layout';
import Devices from './page/test';
import BulkSend from './page/bulkSend';
import AllDevices from './page/allDevices';
import SendMessage from './page/sendMessage';
import WhatsAppBulkSender from './page/WhatsAppBulkSender';



function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* All routes inside here will have the Sidebar and Header */}
        <Route path="/" element={<Layout />}>
          <Route path='/' element={<AllDevices/>} />
          <Route path='/bulk-send' element={<BulkSend/>}/>
          <Route path='/send-message' element={<SendMessage/>}/>
          <Route path='/test-message-sent' element={<WhatsAppBulkSender/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;